module.exports = __webpack_public_path__ + "static/img/basic01.ceb9016d.png";